var _path;
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z"
  }));
};
export default SvgArrowLeft;